import { NavLink, useLocation } from "react-router-dom";
import "./FloatingNavbar.css";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/features", label: "Features" },
  { to: "/workflow", label: "Workflow" },
];

export default function FloatingNavbar() {
  const location = useLocation();
  const isHomeActive = location.pathname === "/" || location.pathname === "/login";

  return (
    <header className="floating-navbar" aria-label="Primary">
      <div className="floating-navbar__inner">
        <NavLink to="/" className="floating-navbar__brand" aria-label="techiohisab home">
          <span className="floating-navbar__brand-techio">techio</span>
          <span className="floating-navbar__brand-hisab">hisab</span>
          <span className="floating-navbar__brand-dot" aria-hidden="true" />
        </NavLink>

        <nav className="floating-navbar__nav" aria-label="Primary navigation">
          {navLinks.map((link) => {
            if (link.to === "/") {
              return (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end
                  className={`floating-navbar__link ${isHomeActive ? "is-active" : ""}`}
                >
                  {link.label}
                </NavLink>
              );
            }

            return (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `floating-navbar__link ${isActive ? "is-active" : ""}`
                }
              >
                {link.label}
              </NavLink>
            );
          })}
        </nav>

        <NavLink to="/about" className="floating-navbar__cta">
          techiohisab.com
        </NavLink>
      </div>
    </header>
  );
}
